export const defaultRun = beforeFn =>
  [
    '$rootScope', '$state', 'ApplicationService', 'CustomerApplicationService',
      function($rootScope, $state, ApplicationService, CustomerApplicationService) {
      if (beforeFn) {
        beforeFn({
          $rootScope,
          $state,
          ApplicationService,
          CustomerApplicationService,
        });
      }

      $rootScope.$on('$stateChangeStart', function(
        event,
        toState,
        toParams,
        fromState,
        fromParams
      ) {
        if (
          _.contains(CustomerApplicationService.static_routes, toState['name']) ||
          (toState['name'] == 'customer_application' &&
            toParams['stage'] == 'home')
        ) {
          return;
        }

        if (
          !ApplicationService.response_data ||
          !_.contains(
            ApplicationService.response_data.viewable_pages,
            toParams.stage
          )
        ) {
          event.preventDefault();
          $state.go('loading');
        }
      });
    }
  ]

const angularAvant = (runFn = defaultRun()) =>
  angular
    .module('angularAvant')
    .run(runFn)
    .config([
      '$asideProvider',
      function($asideProvider) {
        angular.extend($asideProvider.defaults, {
          container: 'body',
          html: true
        });
      }
    ])
    .config([
      '$locationProvider',
      function($locationProvider) {
        $locationProvider.html5Mode(false);
        $locationProvider.hashPrefix('!');
      }
    ])
    .config([
      'avantRouterProvider',
      function(avantRouterProvider) {
        avantRouterProvider.configureHttpProvider();
        avantRouterProvider.configureDefaultStates();
      }
    ])
    .config([
      '$httpProvider',
      function($httpProvider) {
        const getToken = function() {
          // Rails 3+
          let el = document.querySelector('meta[name="csrf-token"]');
          if (el) {
            el = el.getAttribute('content');
          } else {
            // Rails 2
            el = document.querySelector('input[name="authenticity_token"]');
            if (el) {
              el = el.value;
            }
          }
          return el;
        };
        const updateToken = function() {
          let headers = $httpProvider.defaults.headers.common;
          const token = getToken();
          if (token) {
            headers['X-CSRF-TOKEN'] = token;
            headers['X-Requested-With'] = 'XMLHttpRequest';
          }
        };

        updateToken();

        if (window['Turbolinks']) {
          document.addEventListener('page:change', updateToken);
        }
      }
    ]).config(['$qProvider', function ($qProvider) {
        // As of version 1.6, AngularJS raises an error on unhandled rejections by
        // default. Because this app was built in AngularJS 1.2, we didn't take this
        // into account when writing methods like CustomerApplicationsMixinCtrl.updateData(),
        // and rejecting those promises is sometimes normal.
        //
        // Logging those rejections generates enough errors to overwhelm Sentry, so
        // we're turning the errors off to fix that problem without breaking any
        // behavior that depends on the promises not resolving.
        $qProvider.errorOnUnhandledRejections(false);
    }]);;

export default angularAvant;
